import { prop } from "fw";
import { DataDictionaryIndexStatus } from "models/data-dictionary";

export class IndexStatusIcon {
  @prop(null) public value: DataDictionaryIndexStatus;
}
